import React from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@mui/material'

interface Column {
    id: string
    label: string
    align?: 'left' | 'center' | 'right'
}

interface DataRow {
    [key: string]: any
}

interface DataTableProps<T extends DataRow> {
    columns: Column[]
    data: T[]
}

export function DataTable<T extends DataRow>({
    columns,
    data,
}: DataTableProps<T>) {
    return (
        <TableContainer
            component={Paper}
            style={{ background: 'transparent', border: '1px solid white' }}
        >
            <Table style={{ width: '1200px' }}>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align || 'left'}
                                style={{ color: 'white' }}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align || 'left'}
                                    style={{ color: 'white' }}
                                >
                                    {row[column.id]}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
